<template>
    <div :class="getClassName()" class="activity-program__icons">
        <i class="svg-icon" :class="'svg-icon__' + getClassName() + '-1'"></i>
        <i class="svg-icon" :class="'svg-icon__' + getClassName() + '-2'"></i>
        <i class="svg-icon" :class="'svg-icon__' + getClassName() + '-3'"></i>
        <i class="svg-icon" :class="'svg-icon__' + getClassName() + '-4'"></i>
    </div>
</template>

<script>
export default {
    props: {
        activity: {
            type: Object,
            default() {
                return {};
            }
        },
        classname: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {};
    },
    methods: {
        getClassName() {
            return !Object.keys(this.activity).length === 0
                ? this.activity.themes[0].classname
                : this.classname;
        }
    }
};
</script>

<style lang="scss" scoped>
.activity-program__icons {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    pointer-events: none;
}

.svg-icon:nth-child(1) {
    position: absolute;
    z-index: 10;
    left: 0;
    opacity: 0.2;
    top: 10%;
    height: 100px;
    width: 100px;
    transform: translateY(10%) scaleX(-1) rotate(-15deg);

    @include media-breakpoint-up(lg) {
        left: -50px;
        opacity: 1;
    }
}

.svg-icon:nth-child(2) {
    position: absolute;
    z-index: 10;
    right: 0;
    opacity: 0.2;
    top: 60%;
    height: 100px;
    width: 100px;
    transform: rotate(15deg);

    @include media-breakpoint-up(lg) {
        right: -50px;
        opacity: 1;
    }
}

.svg-icon:nth-child(3) {
    position: absolute;
    z-index: 10;
    right: 0;
    opacity: 0.2;
    top: 0;
    height: 100px;
    width: 100px;
    transform: rotate(-15deg);

    @include media-breakpoint-up(lg) {
        right: -50px;
        opacity: 1;
    }
}

.svg-icon:nth-child(4) {
    position: absolute;
    z-index: 10;
    left: 0;
    opacity: 0.2;
    bottom: 0;
    height: 100px;
    width: 100px;
    transform: rotate(-15deg);

    @include media-breakpoint-up(lg) {
        left: -50px;
        opacity: 1;
    }
}
</style>
